import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const UserLevels = ({ data, handleChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Level</InputLabel>
      <Select
        name="level"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Age"
        onChange={handleChange}
        value={data.level ? data.level : ""}>
        <MenuItem value="LEVEL_01">LEVEL 01</MenuItem>
        <MenuItem value="LEVEL_02">LEVEL 02</MenuItem>
        <MenuItem value="LEVEL_03">LEVEL 03</MenuItem>
        <MenuItem value="LEVEL_04">LEVEL 04</MenuItem>
        <MenuItem value="LEVEL_05">LEVEL 05</MenuItem>
        <MenuItem value="LEVEL_06">LEVEL 06</MenuItem>
        <MenuItem value="LEVEL_07">LEVEL 07</MenuItem>
        <MenuItem value="LEVEL_08">LEVEL 08</MenuItem>
        <MenuItem value="LEVEL_09">LEVEL 09</MenuItem>
        <MenuItem value="LEVEL_10">LEVEL 10</MenuItem>
      </Select>
    </FormControl>
  );
};

export default UserLevels;
